import { getApiBaseUrl } from '~/utils'

export const state = () => ({
  zzimList: []
})

export const mutations = {
  SET_ZZIM_LIST (state, list) {
    console.log('SET_ZZIM_LIST 호출됨:', list)
    state.zzimList = list
  },
  TOGGLE_ZZIM_ITEM (state, { pdNo, zzimYn }) {
    if (zzimYn === 'Y') {
      state.zzimList.push({ pdNo })
    } else {
      state.zzimList = state.zzimList.filter(i => i.pdNo !== pdNo)
    }
  }
}

export const actions = {
  async fetchZzimList ({ commit, rootGetters }) {
    try {
      const mbMngNo = rootGetters['session/getMbMngNo']
      console.log('mbMngNo:', mbMngNo)
      console.log('mbMngNo 타입:', typeof mbMngNo)

      if (!mbMngNo || mbMngNo === 'undefined' || mbMngNo === '') {
        console.log('유효하지 않은 mbMngNo - 로그인 필요')
        commit('SET_ZZIM_LIST', [])
        return []
      }

      console.log('찜 API 호출 시작 - mbMngNo:', mbMngNo)
      const response = await this.$axios.post(getApiBaseUrl() + '/pd/pdt/zzim/selZzimPdList', { mbMngNo })

      const list = response.data?.data?.pdZzimList?.map(item => ({
        pdNo: item.pdNo
      })) || []

      commit('SET_ZZIM_LIST', list)
      return list
    } catch (error) {
      console.error('찜 목록 조회 실패:', error)
      commit('SET_ZZIM_LIST', [])
    }
  },

  async toggleZzim ({ commit }, pdNo) {
    const res = await this.$axios.post(getApiBaseUrl() + '/pd/pdr/pdDtl/tglPdDtlZzim', { pdNo })
    if (res.data.success) {
      const zzimYn = res.data.extraData.zzimYn ? 'Y' : 'N'
      commit('TOGGLE_ZZIM_ITEM', { pdNo, zzimYn })
    }

    return res
  }
}
